<template>
    <footer id="footer" class="footer">
        <div class="btns">
            <a class="btn-logo-custom kikkoman_click" href="https://www.kikkoman.com.tw/" target="_blank" rel="noreferrer noopener"></a>
            <a class="btn-facebook Fb_click" href="https://www.facebook.com/KikkomanYummySOP/" target="_blank" rel="noreferrer noopener"></a>
        </div>
    </footer>
</template>

<script>
export default {
    name: "FooterComponent",
};
</script>